import { render, staticRenderFns } from "./assetDetails.vue?vue&type=template&id=31a5420c&scoped=true"
import script from "./assetDetails.vue?vue&type=script&lang=js"
export * from "./assetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5420c",
  null
  
)

export default component.exports